<template>
  <div class="quotationIntegration">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.onlineOrder.cargoCategorySn }}：{{ item.CargoCategory }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.firstWeightSn }}：{{ item.FirstWeightStr }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.firstWeightPrice }}：{{ item.FirstWeightPriceStr }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.continueWeightSn }}：{{ item.ContinuousWeightStr }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.continuePrice }}：{{ item.ContinuousWeightPriceStr }}
        </div>
        <div class="list-item" v-if="item.PRId">
          {{ $t.onlineOrder.pointsObtainConditions }}：{{
            item.PointsObtainConditionsStr
          }}
        </div>
        <div class="list-item" v-if="item.PRId">
          {{ $t.onlineOrder.pointsIncome }}：{{ item.PointsIncome }}
        </div>
        <div class="list-item" v-if="item.PRId">
          {{ $t.onlineOrder.reducedPointsIncome }}：{{ item.ReducedPointsIncome }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogShow(item)"
            >{{ $t.onlineOrder.addRule }}</van-button
          >
          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="dialogDeleteShow(item.PRId)"
            v-if="item.PRId"
            >{{ $t.onlineOrder.deleteRule }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-dialog
      :title="$t.onlineOrder.addRule"
      width="90%"
      v-model="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="addFreightPricePointsRules"
      :cancel-button-text="$t.meta.cancel"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="quotationIntegration-alert">
          <van-form label-width="120px">
            <van-field
              v-model="dialogForm.PointsObtainConditions"
              :label="
                $t.onlineOrder.pointsObtainConditions +
                '(' +
                (dialogForm.WeightUnit == 1 ? 'kg' : 'cbm') +
                ')'
              "
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
              required
            />

            <van-field
              v-model="dialogForm.PointsIncome"
              :label="$t.onlineOrder.pointsIncome"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
              required
            />

            <van-field
              v-model="dialogForm.ReducedPointsIncome"
              :label="$t.onlineOrder.reducedPointsIncome"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
              required
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteFreightPricePointsRulesByPRId"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoHistory">{{
        $t.onlineOrder.viewRuleHistory
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { List, Row, Col, Button, Form, Field } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button).use(Form).use(Field);

export default {
  name: "quotationIntegration",
  data() {
    return {
      FPId: "",
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //删除
      showDeleteDialog: false,
      dialogDeleteId: null,
      //添加
      dialogVisible: false,
      dialogForm: {
        FPId: null,
        FPDId: null,
        WeightUnit: null,
        PointsObtainConditions: null,
        PointsIncome: null,
        ReducedPointsIncome: null,
      },
    };
  },
  created() {
    const { FPId } = this.$route.query;
    this.FPId = FPId;
  },
  methods: {
    addFreightPricePointsRules() {
      this.$commonMethod.showLoading();
      var param = this.dialogForm;
      this.$api.onlineOrderManagement
        .addFreightPricePointsRules(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showDeleteDialog = false;
          this.initList();
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogShow(item) {
      this.dialogForm.FPId = item.FPId;
      this.dialogForm.FPDId = item.FPDId;
      this.dialogForm.WeightUnit = item.WeightUnit;
      this.dialogForm.PointsObtainConditions = null;
      this.dialogForm.PointsIncome = null;
      this.dialogForm.ReducedPointsIncome = null;
      this.dialogVisible = true;
    },
    gotoHistory() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quotationIntegrationHistory",
        name: "quotationIntegrationHistory",
        query: [
          {
            name: "FPId",
            value: this.FPId,
          },
        ],
      });
    },
    deleteFreightPricePointsRulesByPRId() {
      this.$commonMethod.showLoading();
      var param = {
        PRId: this.dialogDeleteId,
      };
      this.$api.onlineOrderManagement
        .deleteFreightPricePointsRulesByPRId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showDeleteDialog = false;
          this.initList();
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    getList() {
      var param = {
        FPId: this.FPId,
      };
      this.$api.onlineOrderManagement
        .getFreightPricePointsRulesListByFPId(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.quotationIntegration {
  width: 100%;
  display: inline-block;
  .list {
    .list-container {
      margin-top: 10px;
      font-size: 12px;
      color: #333;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      padding: 10px;
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .quotationIntegration-alert {
    overflow: scroll;
    height: 50vw;
    margin-top: 30px;
    margin-bottom: 30px;
    .multi-table {
      .multi-table-header {
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
